import styled from "styled-components";

export const DownloadDocumentsWrapper = styled.div``

export const DownloadLink = styled.div`
    margin-top: 4rem;
    display: flex;
    align-items: center;
`

export const IconWrapper = styled.span`
    margin-right: 1rem;
    transform: scale(1.5);
`